<template>
  <div>
    <fdw-ticker client="114" accent-color="#E42C2C"></fdw-ticker>
  </div>
</template>

<script>
export default {
  name: "NflTicker",
};
</script>
